import { FieldError } from "@nt/ui/field";

import { Section } from "@/components/section";
import { SwitchRow } from "@/components/switch";
import { messageOf } from "@/lib/api";
import type { Session } from "@/lib/queries";
import { useWrite } from "@/lib/queries";

/** The Settings › Notifications tab: one switch, saved as soon as it moves. */
export function NotificationsTab({
  session,
  readOnly,
}: {
  session: Session;
  readOnly: boolean;
}) {
  const prefs = useWrite<unknown, unknown>("/api/partner/notifications", [
    "session",
  ]);
  const saved = session.partner?.notifyEarnings ?? true;
  // Show the value being saved while the write runs, then the session's.
  const pendingValue = prefs.isPending
    ? (prefs.variables as { notifyEarnings?: boolean } | undefined)
        ?.notifyEarnings
    : undefined;
  return (
    <Section
      title="Email notifications"
      description="Security and payout emails always arrive, whatever you choose here."
    >
      <div className="grid gap-3">
        <SwitchRow
          id="notify-earnings"
          label="Email me when I earn a new fee"
          description="One email for each new fee, when a customer you referred pays."
          checked={pendingValue ?? saved}
          disabled={readOnly || prefs.isPending}
          onCheckedChange={(on) => prefs.mutate({ notifyEarnings: on })}
        />
        {prefs.isError ? (
          <FieldError role="alert">{messageOf(prefs.error)}</FieldError>
        ) : null}
        {readOnly ? (
          <p className="text-sm text-muted-foreground">
            Your account is read-only, so this cannot be changed.
          </p>
        ) : null}
      </div>
    </Section>
  );
}
